export default class NewCustomer {
    userId: string = "";
    userPassword: string = "";
    nickname: string = "";
    firstName: string = "";
    lastName: string = "";
    address1: string = "";
    address2: string = "";
    city: string = "";
    state: string = "";
    zipcode: string = "";
    country: string = "";
    email: string = "";
    phoneCountryCode: string = "";
    phone: string = "";
    companyEmployeeId: string = "";
    productIds: number[] = [];
}